import * as React from 'react'
import { View } from 'react-native'
import Svg, { Circle, Ellipse, Path, Rect } from 'react-native-svg'
import type { SvgProps } from 'react-native-svg'

export const SvgProgramming = (props: SvgProps) => (
  <View>
    {
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        data-name="Layer 1"
        viewBox="0 0 786.82 572.258"
        {...props}
      >
        <Circle cx={458.321} cy={74.182} r={26.701} fill="#f2f2f2" />
        <Path
          fill="#f2f2f2"
          d="M665.447 497.152c39.688-30.229 58.644-81.026 46.777-129.482q-.442-1.806-.934-3.604c-7.867-28.764-27.331-56.1-55.7-65.291-23.82-7.717-49.82-1.783-74.67-4.852-48.78-6.024-86.6-45.494-113.21-86.82-26.611-41.325-47.062-87.583-82.422-121.723-58.285-56.276-153.362-68.392-225.627-31.76C87.397 90.25 41.365 171.52 43.328 252.513c1.963 80.995 50.046 158.432 119.875 199.517 25.652 15.093 55.321 25.786 84.848 22.044 25.62-3.246 48.9-17.012 74.399-21.1 40.09-6.425 79.927 11.701 114.602 32.824 34.676 21.123 68.17 46.16 107.575 55.953 38.261 9.508 85.663-17.822 120.82-44.6Z"
        />
        <Path
          fill="#3f3d56"
          d="M608.426 55.32c-.87-.58-1.75-1.13-2.62-1.69a380.24 380.24 0 0 0-80.31-38.93l-6.54 90.22h-41.46V1.53c-2.61-.54-5.24-1.05-7.87-1.53v104.92h-49.27A102.27 102.27 0 0 1 318.086 2.65c-2.64.57-5.26 1.18-7.88 1.83v100.44h-40.13l-6.23-86.03a380.858 380.858 0 0 0-81.94 43.53c-.44.3-.88.61-1.31.91-2.21 1.55-4.39 3.13-6.56 4.73v344.19h118.27l-2.09-28.95-11.5-158.95h231.59l-11.5 158.95-2.09 28.95h116.96V58.8q-2.61-1.77-5.25-3.48ZM310.206 198.1h-33.39l-6.17-85.3h39.56Zm159.42 0h-56.08v-1.69a6.18 6.18 0 0 0-6.19-6.18h-24.38a6.178 6.178 0 0 0-6.18 6.18v1.69h-58.71v-85.3h151.54Zm7.87 0v-85.3h40.89l-6.17 85.3ZM0 434.29a289.003 289.003 0 0 0 28.12 28.95l730.58 1a289.003 289.003 0 0 0 28.12-28.95Z"
        />
        <Path
          fill="#3f3d56"
          d="M495.43 341.591v85.704a4.122 4.122 0 0 0 4.119 4.12h127.004a4.122 4.122 0 0 0 4.12-4.12v-85.704a4.124 4.124 0 0 0-4.12-4.114H499.55a4.124 4.124 0 0 0-4.12 4.114Z"
        />
        <Path
          fill="#A8DFD3"
          d="M498.41 342.658v83.58a2.205 2.205 0 0 0 2.2 2.201h124.886a2.205 2.205 0 0 0 2.202-2.2v-83.581a2.206 2.206 0 0 0-2.202-2.206H500.611a2.206 2.206 0 0 0-2.202 2.206Z"
        />
        <Path
          fill="#2f2e41"
          d="M492.774 444.01a2.47 2.47 0 0 0 1.943.93H630.71a2.502 2.502 0 0 0 2.446-3.016l-2.11-10.027a2.507 2.507 0 0 0-1.559-1.818 2.425 2.425 0 0 0-.888-.168H496.82a2.424 2.424 0 0 0-.888.168 2.507 2.507 0 0 0-1.558 1.818l-2.111 10.027a2.5 2.5 0 0 0 .51 2.086Z"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={830.034}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 728.833 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={821.657}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 720.456 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={813.28}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 712.08 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={804.903}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 703.702 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={796.526}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 695.325 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={788.149}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 686.948 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={779.772}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 678.571 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={771.395}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 670.194 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={763.018}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 661.817 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={754.641}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 653.44 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={746.264}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 645.063 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={737.887}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 636.686 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={729.51}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 628.31 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={721.133}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 619.932 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={712.756}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 611.555 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={704.379}
          y={595.588}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 603.178 514.91)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={830.133}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 728.932 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={821.756}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 720.555 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={813.379}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 712.178 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={805.002}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 703.801 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={796.625}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 695.424 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={788.248}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 687.047 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={779.871}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 678.67 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={771.494}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 670.293 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={763.117}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 661.916 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={754.74}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 653.54 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={746.363}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 645.162 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={737.986}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 636.785 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={729.609}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 628.408 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={721.232}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 620.031 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={712.855}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 611.654 519.098)"
        />
        <Rect
          width={4.188}
          height={2.513}
          x={704.478}
          y={599.777}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 603.277 519.098)"
        />
        <Rect
          width={33.508}
          height={2.513}
          x={760.604}
          y={604.803}
          fill="#3f3d56"
          rx={0.488}
          transform="rotate(-180 674.063 524.124)"
        />
        <Rect width={5.966} height={3.122} x={515.631} y={358.737} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={548.154} y={358.737} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={557.369} y={358.737} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={524.477} y={358.477} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={567.841} y={358.477} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={524.304} y={365.784} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={556.827} y={365.784} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={566.042} y={365.784} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={533.15} y={365.523} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={576.514} y={365.523} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={532.977} y={372.83} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={565.5} y={372.83} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={574.715} y={372.83} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={541.823} y={372.57} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={585.187} y={372.57} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={541.649} y={379.877} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={574.172} y={379.877} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={583.387} y={379.877} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={550.496} y={379.617} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={548.154} y={407.898} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={557.369} y={407.898} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={567.841} y={408.158} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={515.631} y={407.898} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={524.477} y={408.158} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={524.304} y={400.851} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={556.827} y={400.851} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={566.042} y={400.851} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={533.15} y={401.111} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={532.977} y={393.804} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={565.5} y={393.804} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={574.715} y={393.804} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={541.823} y={394.064} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={541.649} y={386.758} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={574.172} y={386.758} fill="#fff" rx={1.561} />
        <Rect width={5.966} height={3.122} x={583.387} y={386.758} fill="#fff" rx={1.561} />
        <Rect width={20.796} height={3.122} x={550.496} y={387.018} fill="#fff" rx={1.561} />
        <Path
          fill="#ffb6b6"
          d="m504.917 490.482-13.35-21.102 41.903-33.403 17.295-19.16a19.161 19.161 0 0 1 32.418 6.827 19.161 19.161 0 0 1-11.57 23.991l-27.349 10.075Z"
        />
        <Path
          fill="#2f2e41"
          d="M191.69 337.48v102.56h71.85V337.48a3.448 3.448 0 0 0-2.43-3.3 3.175 3.175 0 0 0-1.03-.16h-64.92a3.463 3.463 0 0 0-3.47 3.46Zm28.04 35.24a7.67 7.67 0 0 1 15.34 0v11.9a7.67 7.67 0 0 1-15.34 0Z"
        />
        <Path
          fill="#3f3d56"
          d="M191.47 436.76v9.89a1.946 1.946 0 0 0 1.93 1.94h68.43a1.94 1.94 0 0 0 1.93-1.94v-9.89ZM78.66 182.96v187.26a9.007 9.007 0 0 0 9 9h277.5a9.007 9.007 0 0 0 9-9V182.96a9.011 9.011 0 0 0-9-8.99H87.66a9.012 9.012 0 0 0-9 8.99Z"
        />
        <Path
          fill="#fff"
          d="M85.17 185.29v182.62a4.818 4.818 0 0 0 4.81 4.81h272.87a4.818 4.818 0 0 0 4.81-4.81V185.29a4.82 4.82 0 0 0-4.81-4.82H89.98a4.82 4.82 0 0 0-4.81 4.82Z"
        />
        <Path
          fill="#2f2e41"
          d="M135.81 447.92a2.948 2.948 0 0 0 2.32 1.11h162.34a2.987 2.987 0 0 0 2.92-3.6l-2.52-11.97a2.993 2.993 0 0 0-1.86-2.17 2.895 2.895 0 0 0-1.06-.2H140.64a2.894 2.894 0 0 0-1.06.2 2.992 2.992 0 0 0-1.86 2.17l-2.52 11.97a2.985 2.985 0 0 0 .61 2.49Z"
        />
        <Path fill="#3f3d56" d="M353.994 205.628H98.671a1.016 1.016 0 0 1 0-2.031h255.323a1.016 1.016 0 0 1 0 2.03Z" />
        <Ellipse cx={116.051} cy={192.33} fill="#3f3d56" rx={5.95} ry={6.083} />
        <Ellipse cx={136.607} cy={192.33} fill="#3f3d56" rx={5.95} ry={6.083} />
        <Ellipse cx={157.163} cy={192.33} fill="#3f3d56" rx={5.95} ry={6.083} />
        <Path
          fill="#3f3d56"
          d="M341.616 187.75h-14.6a1.105 1.105 0 0 0 0 2.21h14.6a1.105 1.105 0 0 0 0-2.21ZM341.616 191.9h-14.6a1.105 1.105 0 0 0 0 2.21h14.6a1.105 1.105 0 0 0 0-2.21ZM341.616 196.05h-14.6a1.105 1.105 0 0 0 0 2.21h14.6a1.105 1.105 0 0 0 0-2.21Z"
        />
        <Path
          fill="#2f2e41"
          d="M693.596 441.101a6.416 6.416 0 0 0 6.183 4.331l26.492-.682a6.329 6.329 0 0 0 5.98-4.657l3.75-40.087a9.794 9.794 0 0 0 4.237.871 9.661 9.661 0 1 0-.485-19.317 8.184 8.184 0 0 0-1.736.181 6.548 6.548 0 0 0-4.874-2.103l-40.75 1.052a5.853 5.853 0 0 0-1.006.125 6.365 6.365 0 0 0-4.873 8.265Zm43.173-43.817 2.668-9.552a6.506 6.506 0 0 0 .02-3.375c.13 0 .244-.062.373-.062a6.91 6.91 0 0 1 .324 13.817 6.505 6.505 0 0 1-3.385-.828Z"
        />
        <Path
          fill="#3f3d56"
          d="M691.387 380.815c.869 4.964 10.63 8.454 22.366 7.847 10.793-.497 19.618-4.287 21.235-8.778a6.025 6.025 0 0 0-1.845-.246l-40.75 1.052a5.853 5.853 0 0 0-1.006.125Z"
        />
        <Path
          fill="#A8DFD3"
          d="M715.904 419.073a.497.497 0 0 0 .151-.066l5.753-3.766a.5.5 0 0 0 0-.836l-5.98-3.917a.5.5 0 1 0-.547.836l5.34 3.498-5.113 3.348a.5.5 0 0 0 .396.903ZM706.818 419.492a.5.5 0 0 0 .126-.918l-5.303-3.04 5.125-3.808a.5.5 0 1 0-.596-.802l-5.738 4.263a.5.5 0 0 0 .049.834l5.965 3.42a.5.5 0 0 0 .372.051ZM715.332 422.373a.482.482 0 0 0 .137-.058.5.5 0 0 0 .168-.687l-8.156-13.408a.5.5 0 0 0-.854.52l8.155 13.409a.5.5 0 0 0 .55.224Z"
        />
        <Rect width={50.719} height={10.846} x={209.385} y={260.827} fill="#A8DFD3" rx={3.264} />
        <Rect width={102.236} height={10.846} x={183.626} y={282.519} fill="#e6e6e6" rx={3.264} />
        <Rect width={102.236} height={10.846} x={183.626} y={304.21} fill="#e6e6e6" rx={3.264} />
        <Path
          fill="#3f3d56"
          d="m290.711 376.846.217.684.011.023 6.526 19.838 7.506 22.861 14.122 42.961.137 6.674v.023l1.05 53.684-2.91 7.278 3.275 11.933s-1.506-18.037-9.582-7.68c-4.575 5.887-9.925 11.91-14.317 17.557q9.6 3.885 19.507 7.027c1.426.457 2.863.89 4.3 1.324l.925.273a266.863 266.863 0 0 0 67.35 10.826c1.187.035 2.35.057 3.48.08.4.012.787.023 1.175.023 1.278.011 2.544.023 3.821.023q3.868 0 7.7-.114a266.853 266.853 0 0 0 56.092-7.586c-.125-7.586-.468-16.45-.958-25.919-.228-4.643-5.35-9.673-5.658-14.533-.217-3.65 4.38-7.084 4.14-10.792-1.55-22.826-3.49-14.064-4.927-30.228q-.223-2.379-.411-4.552c-.924-10.381-1.563-16.872-1.563-16.872l6.137-38.683 9.64-60.735-.742-1.22-.832-.411-50.844-25.166-2.761-7.072a10.979 10.979 0 0 0-10.141-6.948l-33.493-.136a10.931 10.931 0 0 0-8.91 4.528l-9.069 12.56Z"
        />
        <Path
          fill="#3f3d56"
          d="m326.816 453.654-7.586 16.233-5.179 11.088-8.909 46.646-4.46 4.734-3.822-16.76-39.998 8.882c-1.312-7.29-.351.246-1.16-7.75.227-.228.467-.457.706-.685.64-.593 1.175-1.152 1.164-1.688-.456-27.584.913-74.526 12.343-102.966a60.053 60.053 0 0 1 7.027-13.107c.228-.308.445-.616.662-.924 5.27-7.38 8.601-14.648 13.324-19.815v-.012a.53.53 0 0 0 .08-.08.157.157 0 0 0 .045-.034l32.444-17.203 1.392 39.106.992 28.108ZM443.801 458.264l9.476 20.275 3.308 7.061 8.907 46.642 4.445 4.723 3.83-16.756 1.8-.369 32.459-6.722 9.46 30.046a17.984 17.984 0 0 0-3.26-22.506c-.647-.584-1.185-1.153-1.17-1.692.539-32.443-1.446-91.683-19.367-116.066-5.692-7.737-9.107-15.444-14.076-20.828-.015-.016-.015-.031-.03-.031l-12.092-19.798-.738-1.216-.83-.415Z"
        />
        <Circle cx={386.397} cy={267.201} r={44.558} fill="#ffb6b6" data-name="Ellipse 5" />
        <Path
          fill="#2f2e41"
          d="M446.622 236.077a3.76 3.76 0 0 0-2.69-1.19l.67-1.86a3.528 3.528 0 0 0-3.96-4.7l-2.44.47.23-1.63a3.534 3.534 0 0 0-4.73-3.82 3.766 3.766 0 0 1-3.24-.23 3.846 3.846 0 0 1-1.92-2.61l-.85-4.1-.09-.22c-4.14-6.9-12.1-11.92-21.84-13.76-8.67-1.65-17.56-.81-26.13-.02-3.4.32-7.24.68-10.44 2.64-2.72 1.68-5.02 5.04-4.55 8.43-8.45-2.59-17.51 2.58-22 9.1-5.32 7.76-6.19 17.48-6.33 25.08-.38 17.98 3.33 32.69 11 43.73.56.8.7 2.47 1.81 3.03l-.23-.37c1.24.62 2.5 1.62 2.03 2.69-1.35 3.08 7.62 9.89 13.94 12.14 11.53 4.11 26.86 3.76 37.64 2.28l.38-2.55c3.89-.53 6.63-1.54 7.4-3.12 1.36-1.16 2.52-2.2 3.53-3.16l.01-.01c.02-.02.06-.05.08-.07 4.87-4.67 6-7.33 6.51-11.38.49-3.97-.38-8-1.27-11.63 18.74 2.9-7.38-19.96 10.08-24.38a5.434 5.434 0 0 1 .61-.15c.51-.12 1.02-.24 1.51-.38a26.448 26.448 0 0 0 6.72-2.87c4.88-2.97 6.49-6.91 9.01-11.35a3.427 3.427 0 0 0-.45-4.03ZM543.992 461.437c-.01 1.75-.03 4.2-.11 7.23l-.03 1.29c-.13 5.57-.26 10.24-.47 15.43-.01.36-.02.71-.04 1.07-.28 7.24-.72 15.67-1.48 29.02-1.41 24.66-3.87 3.39-6.34 12.04-.12.43-.25.94-.37 1.54a27.916 27.916 0 0 1-1.88 6.33c-1.31.78-2.66 1.53-3.99 2.28-3.79 2.11-7.64 4.14-11.52 6.07-2.18 1.08-4.37 2.14-6.57 3.16-.35.16-.69.32-1.03.47a270.887 270.887 0 0 1-34.75 13.26c-2.32.7-4.63 1.38-6.97 2.01-2.44.68-4.88 1.32-7.35 1.92a266.893 266.893 0 0 1-56.09 7.59c-2.55.08-5.12.11-7.7.11-1.28 0-2.54-.01-3.82-.02-.39 0-.78-.01-1.17-.02-1.13-.03-2.3-.05-3.48-.08a266.663 266.663 0 0 1-67.35-10.83l-.93-.27c-1.44-.44-2.87-.87-4.3-1.33q-9.9-3.135-19.51-7.02-7.335-2.955-14.5-6.34a.339.339 0 0 1-.12-.06c-1-.46-2.01-.94-3.01-1.43-.13-.07-.27-.14-.41-.21q-5.595-2.73-11.07-5.72c-3.07-7.05-7.39-8.4-10.07-14.6a25.874 25.874 0 0 1-1.68-5.74c0-.02-.01-.04-.01-.07.28 3.72-1.19-6.6-.01-.04a52.001 52.001 0 0 0-.16-1.75c-3.43-33.49-3.21-71.79-4.7-103.35q-.15-3.06-.31-5.86c-.03-.62-.07-1.23-.11-1.83.07-.18.15-.37.24-.55a1.002 1.002 0 0 1 .07-.15 1.623 1.623 0 0 1 .1-.18l.07-.1a.917.917 0 0 1 .05-.1c.09-.14.19-.29.3-.43.05-.06.09-.11.14-.16a.808.808 0 0 1 .12-.14.637.637 0 0 1 .11-.13c.04-.04.08-.09.13-.14a.302.302 0 0 1 .08-.08 2.033 2.033 0 0 1 .26-.25 9.624 9.624 0 0 1 1.14-.9c.14-.09.29-.18.43-.28a19.135 19.135 0 0 1 3.17-1.52c.38-.14.76-.27 1.17-.41.15-.04.29-.09.44-.14.22-.07.44-.14.67-.19 1.14-.34 2.37-.63 3.7-.9.16-.03.33-.06.5-.1.24-.05.49-.09.74-.13.34-.06.69-.12 1.04-.18 2.97-.47 6.34-.82 10.06-1.05l1.05-.06 1.24-.06c.35-.02.71-.03 1.07-.04.35-.02.71-.03 1.08-.04 1.01-.03 2.05-.06 3.11-.08 3.02-.06 6.2-.04 9.54.03 1.55.04 3.13.08 4.75.15.11 0 .21.01.31.01 1.41.05 2.83.11 4.29.19 1.02.05 2.05.1 3.08.16.97.06 1.95.12 2.94.19.77.04 1.54.1 2.32.15.66.05 1.32.1 1.98.14l.9.06c.49.04.98.07 1.48.12 1.1.09 2.2.18 3.32.27 1.11.1 2.24.2 3.37.3s2.27.21 3.41.32l.34.03c1.04.11 2.08.21 3.13.32.24.02.49.04.73.07 1.001.1 2.022.218 3.032.325l.93.1c.791.087 1.571.161 2.368.255 1.05.12 2.12.23 3.16.37.81.09 1.62.18 2.43.28 1.27.15 2.56.31 3.85.48.49.06.98.12 1.47.19 3.68.46 7.4.97 11.18 1.5 5.73.81 11.55 1.69 17.41 2.64q8.805 1.425 17.71 3.01c1.5.27 3 .54 4.51.82l2.04.39c1.16.21 2.32.43 3.48.65 1.16.22 2.32.44 3.48.67l4.15.81c9.09 1.8 18.13 3.72 26.95 5.73 1.45.33 2.9.67 4.34 1q4.32 1.005 8.56 2.04c.78.18 1.55.37 2.32.56 1.92.48 3.84.96 5.73 1.45l.33.09c1.39.34 2.75.69 4.11 1.05q4.815 1.26 9.47 2.55 3.09.855 6.11 1.73c3.01.87 5.96 1.75 8.83 2.64.71.22 1.42.44 2.12.65 2.1.65 4.17 1.31 6.18 1.97 1.6.52 3.16 1.05 4.7 1.58q2.31.795 4.53 1.59c.95.34 1.89.7 2.83 1.04 1.35.5 2.68 1 3.98 1.5.4.15.79.31 1.18.46.25.11.49.2.73.3.47.19.95.37 1.41.56.47.18.93.37 1.39.57.45.18.91.37 1.35.56.45.18.89.37 1.33.57.37.15.73.31 1.08.47.71.31 1.42.62 2.11.94.34.16.68.31 1.02.47l.78.36c.11.06.22.11.33.16.25.12.51.25.76.37.58.27 1.15.56 1.71.83.75.38 1.48.76 2.18 1.13.71.38 1.4.76 2.06 1.13.11.06.21.12.32.18.15.08.3.17.45.25.51.29 1 .59 1.49.88.96.59 1.87 1.17 2.72 1.75.19.13.37.26.56.38.63.45 1.23.89 1.79 1.34 0 .01 0 .01.01.01.19.14.37.29.55.43.15.14.31.26.46.4.52.45 1 .88 1.44 1.32a5.667 5.667 0 0 1 .42.43 1.208 1.208 0 0 1 .16.16c.2.2.38.4.55.6a.553.553 0 0 1 .07.09c.24.28.46.56.67.84.1.14.21.28.3.42.12.17.24.35.34.52.09.14.17.29.25.43a7.257 7.257 0 0 1 .54 1.13 5.241 5.241 0 0 1 .27.82 5.844 5.844 0 0 1 .17.81Z"
        />
        <Path
          d="M543.992 461.437c-.01 1.75-.03 4.2-.11 7.23-.01.42-.03.85-.04 1.29-.1 4.25-.25 9.5-.46 15.43-.01.36-.02.71-.04 1.07-.28 7.24-.72 15.67-1.48 29.02-1.41 24.66-3.87 3.39-6.34 12.04-6.86-4.22-14.38-8.64-22.42-13.18q-2.175-1.23-4.39-2.47c-16.08-8.97-34.04-18.37-52.79-27.68-.74-.37-1.49-.74-2.23-1.1-42.95-21.23-89.83-41.88-127.81-55.66-7.33-2.66-14.33-5.06-20.91-7.17-13.86-4.43-25.84-7.53-35.06-8.87-9.6-1.4-16.23-.9-18.91 1.99q-.15-3.06-.31-5.86l-.12-1.83c.062-.165.142-.322.22-.48.01-.024.019-.047.03-.07a1.002 1.002 0 0 1 .07-.15 1.623 1.623 0 0 1 .1-.18 1.06 1.06 0 0 1 .12-.2c.09-.14.19-.29.3-.43a3.483 3.483 0 0 1 .26-.3.637.637 0 0 1 .11-.13c.04-.04.08-.09.13-.14a.302.302 0 0 1 .08-.08 2.033 2.033 0 0 1 .26-.25 9.624 9.624 0 0 1 1.14-.9c.14-.09.29-.18.43-.28a19.135 19.135 0 0 1 3.17-1.52c.38-.14.76-.27 1.17-.41.15-.04.29-.09.44-.14.22-.07.44-.14.67-.19 1.14-.34 2.37-.63 3.7-.9.4-.08.82-.16 1.24-.23.34-.06.69-.12 1.04-.18 2.97-.47 6.34-.82 10.06-1.05l1.05-.06 1.24-.06c.35-.02.71-.03 1.07-.04.35-.02.71-.03 1.08-.04 1.01-.03 2.05-.06 3.11-.08 3.02-.05 6.2-.03 9.54.04 1.55.03 3.13.08 4.75.15.1 0 .21.01.31.01 1.41.04 2.84.11 4.29.18 1.02.05 2.05.1 3.08.16.97.06 1.95.12 2.94.19.77.04 1.54.1 2.32.15.66.05 1.32.1 1.98.14l2.38.18c1.1.09 2.2.18 3.32.27 1.11.1 2.24.2 3.37.3s2.27.21 3.41.32l.34.03c1.04.11 2.08.21 3.13.32q8.73.885 17.97 2.07 5.52.705 11.18 1.51c5.73.81 11.55 1.69 17.41 2.63q8.805 1.425 17.71 3.01c1.5.27 3 .54 4.51.82q2.76.51 5.52 1.04c1.16.22 2.32.44 3.48.67l4.15.81c9.09 1.8 18.13 3.72 26.95 5.73 1.45.33 2.9.67 4.34 1q4.32 1.005 8.56 2.04c.78.19 1.55.38 2.32.57q2.895.72 5.73 1.44v.01c.11.02.22.05.33.08 1.38.35 2.75.7 4.11 1.06q4.815 1.26 9.47 2.54c2.06.58 4.1 1.15 6.11 1.73a705.922 705.922 0 0 1 10.95 3.29q3.15.99 6.18 1.97c1.6.52 3.16 1.05 4.7 1.58q2.31.795 4.53 1.59c.96.34 1.9.69 2.83 1.03 1.36.5 2.68 1 3.98 1.51.4.15.79.31 1.18.46.73.28 1.44.57 2.14.86.47.18.93.37 1.39.57.45.18.91.37 1.35.56.45.18.89.37 1.33.57.37.15.73.31 1.08.47.71.31 1.42.62 2.11.94.34.16.68.31 1.02.47l.78.36c.11.06.22.11.33.16.85.4 1.67.8 2.47 1.2.75.38 1.48.76 2.18 1.13.83.44 1.62.87 2.38 1.31.15.08.3.17.45.25.51.29 1 .59 1.49.88.96.59 1.87 1.17 2.72 1.75.84.58 1.62 1.15 2.35 1.72 0 .01 0 .01.01.01.35.28.69.56 1.01.83.52.45 1 .88 1.44 1.32a5.667 5.667 0 0 1 .42.43 1.208 1.208 0 0 1 .16.16c.21.23.42.46.62.69.24.28.46.56.67.84.1.14.21.28.3.42.12.17.24.35.34.52.09.14.17.29.25.43a7.257 7.257 0 0 1 .54 1.13 6.053 6.053 0 0 1 .27.82 5.844 5.844 0 0 1 .17.81Z"
          opacity={0.2}
        />
      </Svg>
    }
  </View>
)
